export enum ProductRegisterType {
  APPETIZER = { code: 'APPETIZER', description: 'PRODUCT.APPETIZER' } as any,
  MAIN_COURSE = { code: 'MAIN_COURSE', description: 'PRODUCT.MAIN_COURSE' } as any,
  DRINKS = { code: 'DRINKS', description: 'PRODUCT.DRINK' } as any,
  DESSERTS = { code: 'DESSERTS', description: 'PRODUCT.DESSERT' } as any,
  OTHERS = { code: 'OTHERS', description: 'PRODUCT.OTHER' } as any,
}



// WEBPACK FOOTER //
// ./src/app/pages/category/products/enum/product-register-type.enum.ts